export const getReleaseVersionText = (releaseVersion: string | undefined) => {
  if (releaseVersion === 'none') return null;
  return releaseVersion ? ` (${releaseVersion})` : null;
};
